export default "__VITE_ASSET__DyIer4WT__"